(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-community-slider]');
    if (!section) return;
    var track = section.querySelector('[data-community-track]');
    var prevBtn = section.querySelector('[data-community-prev]');
    var nextBtn = section.querySelector('[data-community-next]');
    if (!track) return;
    var cards = track.querySelectorAll('.community__card');
    if (cards.length === 0) return;

    var currentIndex = 0;
    var cardWidth = 0;
    var gap = 16;
    var visibleCount = 3;
    var maxIndex = 0;

    function measure() {
      if (cards.length === 0) return;
      cardWidth = cards[0].offsetWidth;
      var wrapper = track.parentElement;
      var w = wrapper ? wrapper.offsetWidth : window.innerWidth;
      if (w <= 640) visibleCount = 1;
      else if (w <= 900) visibleCount = 2;
      else if (w <= 1200) visibleCount = 3;
      else visibleCount = 4;
      maxIndex = Math.max(0, cards.length - visibleCount);
      currentIndex = Math.min(currentIndex, maxIndex);
      update();
    }

    function update() {
      var offset = -(currentIndex * (cardWidth + gap));
      track.style.transform = 'translateX(' + offset + 'px)';
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        update();
      }
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        update();
      }
    });

    window.addEventListener('resize', measure);
    measure();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderController {
    constructor() {
      this.drawer = document.getElementById('drawer-menu');
      this.search = document.getElementById('search-modal');
      this.cartDrawer = document.getElementById('cart-drawer');
      this.body = document.body;
      this.sectionId = this.cartDrawer ? this.cartDrawer.dataset.sectionId : '';
      this.shippingThreshold = this.cartDrawer ? parseInt(this.cartDrawer.dataset.shippingThreshold, 10) || 10000 : 10000;
      this.translations = {};
      const transEl = document.getElementById('header-translations');
      if (transEl) try { this.translations = JSON.parse(transEl.textContent); } catch (e) {}
      
      this.init();
    }

    init() {
      this.bindDrawerEvents();
      this.bindSearchEvents();
      this.bindCartDrawerEvents();
      this.bindMegaMenuEvents();
      this.bindKeyboardEvents();
      document.addEventListener('cart:item-added', () => {
        this.openCartDrawer();
        this.refreshCartDrawer();
      });
    }

    // Drawer Menu
    bindDrawerEvents() {
      const openButtons = document.querySelectorAll('[data-drawer-open]');
      const closeButtons = document.querySelectorAll('[data-drawer-close]');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => this.openDrawer());
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeDrawer());
      });
    }

    openDrawer() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      
      const toggle = document.querySelector('[data-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      // Focus first link + update drawer mega slider indicator (show hint/fade only when scrollable)
      setTimeout(() => {
        const firstLink = this.drawer.querySelector('a');
        if (firstLink) firstLink.focus();
        this.drawer.querySelectorAll('.drawer-menu__mega-slider-wrap').forEach((wrap) => {
          const grid = wrap.querySelector('[data-drawer-mega-slider]');
          const hint = wrap.querySelector('.drawer-menu__mega-scroll-hint');
          const fade = wrap.querySelector('.drawer-menu__mega-fade');
          if (grid && hint && fade) {
            const scrollable = grid.scrollWidth > grid.clientWidth;
            hint.style.display = scrollable ? '' : 'none';
            fade.style.display = scrollable ? '' : 'none';
          }
        });
      }, 400);
    }

    closeDrawer() {
      this.drawer.setAttribute('aria-hidden', 'true');
      this.body.style.overflow = '';
      
      const toggle = document.querySelector('[data-drawer-open]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    }

    // Mega menu: keep open when hovering the panel (panel is position:fixed so :hover is lost)
    bindMegaMenuEvents() {
      const wrappers = document.querySelectorAll('[data-mega-wrapper]');
      wrappers.forEach((wrapper) => {
        const link = wrapper.querySelector('.header__nav-link');
        const panel = wrapper.querySelector('[data-mega-panel]');
        const content = panel?.querySelector('.header__mega-content');
        if (!link || !panel || !content) return;
        let closeTimeout = null;
        const open = () => {
          clearTimeout(closeTimeout);
          wrapper.classList.add('mega-open');
        };
        const close = () => {
          closeTimeout = setTimeout(() => wrapper.classList.remove('mega-open'), 280);
        };
        link.addEventListener('mouseenter', open);
        link.addEventListener('mouseleave', close);
        content.addEventListener('mouseenter', open);
        content.addEventListener('mouseleave', close);
      });
    }

    // Search Modal (no-op if modal was removed)
    bindSearchEvents() {
      if (!this.search) return;
      const openButtons = document.querySelectorAll('[data-search-open]');
      const closeButtons = document.querySelectorAll('[data-search-close]');
      const searchInput = document.querySelector('[data-search-input]');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => this.openSearch());
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeSearch();
        });
      });

      // Predictive search (debounced)
      if (searchInput) {
        let timeout;
        searchInput.addEventListener('input', (e) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.handleSearch(e.target.value);
          }, 300);
        });
      }
    }

    openSearch() {
      if (!this.search) return;
      this.search.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      
      const toggle = document.querySelector('[data-search-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      // Focus input
      setTimeout(() => {
        const input = this.search.querySelector('[data-search-input]');
        if (input) input.focus();
      }, 400);
    }

    closeSearch() {
      const modal = this.search;
      if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
      const toggle = document.querySelector('[data-search-open]');
      modal.classList.add('search-modal--closing');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      const duration = 300;
      setTimeout(() => {
        modal.classList.remove('search-modal--closing');
        modal.setAttribute('aria-hidden', 'true');
        this.body.style.overflow = '';
        if (toggle) toggle.focus();
      }, duration);
    }

    handleSearch(query) {
      if (!query || query.length < 2) {
        const results = document.querySelector('[data-search-results]');
        if (results) results.innerHTML = '';
        return;
      }

      // Fetch predictive search results
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
        .then(response => response.json())
        .then(data => {
          this.displayResults(data);
        })
        .catch(err => console.error('Search error:', err));
    }

    displayResults(data) {
      const resultsContainer = document.querySelector('[data-search-results]');
      if (!resultsContainer) return;

      const products = data.resources?.results?.products || [];
      
      if (products.length === 0) {
        const msg = this.translations.search_no_results || 'Rezultatų nerasta';
        resultsContainer.innerHTML = '<p class="search-modal__results-empty">' + this.escapeHtml(msg) + '</p>';
        return;
      }

      const getProductImageUrl = (product) => {
        let url = product.featured_image || product.image;
        if (!url && product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.url)
          url = product.featured_media.preview_image.url;
        if (url && typeof url === 'object') url = url.url || url.src;
        if (!url || typeof url !== 'string') return '';
        return url.startsWith('//') ? 'https:' + url : url;
      };

      const html = `
        <ul class="search-modal__result-list" role="list">
          ${products.map(product => {
            const imgSrc = getProductImageUrl(product);
            return `
            <li class="search-modal__result">
              <a href="${product.url}" class="search-modal__result-link">
                <span class="search-modal__result-image-wrap">
                  ${imgSrc
                    ? `<img class="search-modal__result-image" src="${imgSrc}" alt="" loading="lazy" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">
                     <span class="search-modal__result-placeholder" style="display:none;" aria-hidden="true">${this.escapeHtml(this.translations.cart_no_image || 'No image')}</span>`
                    : '<span class="search-modal__result-placeholder">' + this.escapeHtml(this.translations.cart_no_image || 'No image') + '</span>'}
                </span>
                <span class="search-modal__result-info">
                  <span class="search-modal__result-title">${this.escapeHtml(product.title)}</span>
                  <span class="search-modal__result-price">${product.price || ''}</span>
                </span>
              </a>
            </li>`;
          }).join('')}
        </ul>
      `;

      resultsContainer.innerHTML = html;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Cart Drawer
    bindCartDrawerEvents() {
      if (!this.cartDrawer) return;
      const openBtns = document.querySelectorAll('[data-cart-drawer-open]');
      const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');
      openBtns.forEach(btn => btn.addEventListener('click', () => this.openCartDrawer()));
      closeBtns.forEach(btn => btn.addEventListener('click', () => this.closeCartDrawer()));
      this.cartDrawer.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('[data-cart-drawer-close]');
        if (closeBtn) {
          e.preventDefault();
          this.closeCartDrawer();
          return;
        }
        const quickAdd = e.target.closest('[data-quick-add-variant]');
        if (quickAdd) {
          e.preventDefault();
          this.quickAdd(quickAdd.dataset.quickAddVariant, quickAdd);
          return;
        }
        const qtyPlus = e.target.closest('[data-cart-qty-plus]');
        if (qtyPlus) {
          e.preventDefault();
          this.cartChange(qtyPlus.dataset.cartQtyPlus, 1);
          return;
        }
        const qtyMinus = e.target.closest('[data-cart-qty-minus]');
        if (qtyMinus) {
          e.preventDefault();
          this.cartChange(qtyMinus.dataset.cartQtyMinus, -1);
          return;
        }
        const remove = e.target.closest('[data-cart-remove]');
        if (remove) {
          e.preventDefault();
          const key = remove.dataset.cartKey || remove.closest('[data-cart-item]')?.dataset?.cartKey;
          if (key) this.cartChange(key, 0);
          return;
        }
        const next = e.target.closest('[data-upsell-next]');
        if (next) {
          e.preventDefault();
          this.setUpsellIndex(1);
          return;
        }
        const prev = e.target.closest('[data-upsell-prev]');
        if (prev) {
          e.preventDefault();
          this.setUpsellIndex(0);
          return;
        }
      });
    }

    setUpsellIndex(index) {
      const track = this.cartDrawer?.querySelector('[data-cart-upsells] .cart-drawer__upsells-track');
      if (!track) return;
      const cards = track.querySelectorAll('[data-cart-upsell]');
      cards.forEach((el, i) => {
        el.classList.toggle('cart-drawer__upsell--active', i === index && !el.classList.contains('cart-drawer__upsell--in-cart'));
      });
      this.updateUpsellArrows();
    }

    updateUpsellArrows() {
      const upsells = this.cartDrawer?.querySelector('[data-cart-upsells]');
      if (!upsells) return;
      const track = upsells.querySelector('.cart-drawer__upsells-track');
      const cards = track ? Array.from(track.querySelectorAll('[data-cart-upsell]')) : [];
      const visible = cards.filter(el => !el.classList.contains('cart-drawer__upsell--in-cart'));
      const activeEl = upsells.querySelector('.cart-drawer__upsell--active');
      const activeIndex = activeEl ? parseInt(activeEl.dataset.upsellIndex, 10) : 0;
      const nextBtn = upsells.querySelector('[data-upsell-next]');
      const prevBtn = upsells.querySelector('[data-upsell-prev]');
      const onlyOneVisible = visible.length < 2;
      if (nextBtn) nextBtn.hidden = onlyOneVisible || activeIndex >= 1;
      if (prevBtn) prevBtn.hidden = onlyOneVisible || activeIndex <= 0;
    }

    productIdKey(value) {
      return String(value == null ? '' : value).split('/').pop();
    }

    cartHasProduct(cart, productId) {
      const target = this.productIdKey(productId);
      if (!target) return false;
      return (cart.items || []).some((item) => this.productIdKey(item.product_id) === target);
    }

    updateUpsellVisibility(cart) {
      const cartProductIds = (cart.items || []).map((item) => this.productIdKey(item.product_id));
      const upsells = this.cartDrawer?.querySelector('[data-cart-upsells]');
      if (upsells) {
        const track = upsells.querySelector('.cart-drawer__upsells-track');
        const cards = track ? Array.from(track.querySelectorAll('[data-cart-upsell]')) : [];
        cards.forEach((el) => {
          const inCart = cartProductIds.includes(this.productIdKey(el.dataset.upsellProductId));
          el.classList.toggle('cart-drawer__upsell--in-cart', inCart);
        });
        const visible = cards.filter((el) => !el.classList.contains('cart-drawer__upsell--in-cart'));
        cards.forEach((el, i) => {
          el.classList.toggle('cart-drawer__upsell--active', visible[0] === el);
        });
        upsells.style.display = visible.length === 0 ? 'none' : '';
        this.updateUpsellArrows();
      }

      const featuredUpsell = this.cartDrawer?.querySelector('[data-cart-featured-upsell]');
      if (featuredUpsell) {
        const featuredInCart = cart.item_count > 0 && this.cartHasProduct(cart, featuredUpsell.dataset.featuredUpsellProductId);
        featuredUpsell.style.display = featuredInCart || cart.item_count === 0 ? 'none' : '';
      }
    }

    openCartDrawer() {
      if (!this.cartDrawer) return;
      this.cartDrawer.setAttribute('aria-hidden', 'false');
      this.body.style.overflow = 'hidden';
      this.body.style.position = 'fixed';
      this.body.style.width = '100%';
      this.body.style.top = `-${window.scrollY}px`;
      this.scrollY = window.scrollY;
      const btn = document.querySelector('[data-cart-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      this.refreshCartDrawer();
    }

    closeCartDrawer() {
      if (!this.cartDrawer) return;
      this.cartDrawer.setAttribute('aria-hidden', 'true');
      this.body.style.overflow = '';
      this.body.style.position = '';
      this.body.style.width = '';
      this.body.style.top = '';
      if (this.scrollY !== undefined) {
        window.scrollTo(0, this.scrollY);
        this.scrollY = undefined;
      }
      const btn = document.querySelector('[data-cart-drawer-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new CustomEvent('cart-drawer:closed'));
    }

    shopifyRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async quickAdd(variantId, button) {
      if (!variantId) return;
      const id = this.productIdKey(variantId);
      const numericId = Number(id);
      const payloadId = Number.isSafeInteger(numericId) ? numericId : id;
      const upsell = button?.closest('[data-cart-featured-upsell], [data-cart-upsell]');
      if (upsell) upsell.style.display = 'none';
      if (button) button.disabled = true;
      try {
        const res = await fetch(this.shopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: payloadId, quantity: 1 })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) throw new Error(data.description || 'Add failed');
        await this.refreshCartDrawer();
      } catch (err) {
        console.error(err);
        if (upsell) upsell.style.display = '';
      }
      if (button) button.disabled = false;
    }

    async cartChange(lineKey, delta) {
      const item = this.cartDrawer.querySelector(`[data-cart-item][data-cart-key="${lineKey}"]`) || this.cartDrawer.querySelector(`[data-cart-qty-minus="${lineKey}"]`)?.closest('[data-cart-item]');
      const qtyEl = item?.querySelector('[data-cart-qty]');
      const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      const newQty = delta === 0 ? 0 : Math.max(0, current + delta);
      try {
        const res = await fetch(this.shopifyRoot() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: newQty })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) throw new Error(data.description || 'Update failed');
        await this.refreshCartDrawer();
      } catch (err) {
        console.error(err);
      }
    }

    async fetchHeaderSectionHtml() {
      const root = this.shopifyRoot();
      const sectionId = this.sectionId || this.cartDrawer?.dataset.sectionId;
      if (!sectionId) return null;
      const res = await fetch(root + '?sections=' + encodeURIComponent(sectionId));
      if (!res.ok) throw new Error('Failed to fetch cart section');
      const data = await res.json();
      return data[sectionId] || Object.values(data)[0] || null;
    }

    externalCheckoutUrl(cart) {
      const cfg = window.AVA_NC_CHECKOUT;
      if (!cfg || !cfg.enabled || !cfg.urls) return '';
      const attrs = (cart && cart.attributes) || {};
      const variantId = attrs.ava_nc_variant;
      if (variantId) {
        const stillThere = (cart.items || []).some((item) => String(item.variant_id) === String(variantId));
        if (!stillThere) return '';
      }
      const direct = String(attrs.ava_nc_url || '').trim();
      if (direct) return direct;
      const key = attrs.ava_nc_key;
      return key ? (cfg.urls[key] || '') : '';
    }

    applyCheckoutDiscount(cart) {
      const checkoutLink = this.cartDrawer?.querySelector('[data-cart-checkout-link]');
      if (!checkoutLink) return;
      const externalUrl = this.externalCheckoutUrl(cart);
      if (externalUrl) {
        checkoutLink.href = externalUrl;
        return;
      }
      if (window.AVA_COMBO_DISCOUNT && window.AVA_COMBO_DISCOUNT.code && Array.isArray(window.AVA_COMBO_DISCOUNT.productIds)) {
        const giftInCart = (cart.items || []).some((item) => window.AVA_COMBO_DISCOUNT.productIds.indexOf(item.product_id) !== -1);
        checkoutLink.href = giftInCart ? '/checkout?discount=' + encodeURIComponent(window.AVA_COMBO_DISCOUNT.code) : '/checkout';
      } else {
        checkoutLink.href = '/checkout';
      }
    }

    updateCartBadge(cart, sectionDoc) {
      const cartBtn = document.querySelector('[data-cart-drawer-open]');
      if (!cartBtn) return;
      const newBadge = sectionDoc?.querySelector('[data-cart-count]');
      const badge = document.querySelector('[data-cart-count]');
      if (newBadge) {
        if (badge) badge.replaceWith(newBadge.cloneNode(true));
        else cartBtn.appendChild(newBadge.cloneNode(true));
        return;
      }
      if (!badge) return;
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = '';
        badge.classList.remove('header__cart-badge--empty');
      } else {
        badge.textContent = '';
        badge.style.display = 'none';
        badge.classList.add('header__cart-badge--empty');
      }
    }

    async refreshCartDrawer() {
      if (!this.cartDrawer) return;
      try {
        const root = this.shopifyRoot();
        const [cart, sectionHtml] = await Promise.all([
          fetch(root + 'cart.js').then((r) => r.json()),
          this.fetchHeaderSectionHtml().catch(() => null)
        ]);

        if (sectionHtml) {
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const newDrawer = doc.getElementById('cart-drawer');
          if (newDrawer) {
            const wasOpen = this.cartDrawer.getAttribute('aria-hidden') !== 'true';
            this.cartDrawer.innerHTML = newDrawer.innerHTML;
            ['data-shipping-threshold', 'data-cart-title', 'data-cart-item-status', 'data-cart-shipping-reached', 'data-section-id'].forEach((attr) => {
              const val = newDrawer.getAttribute(attr);
              if (val != null) this.cartDrawer.setAttribute(attr, val);
            });
            if (wasOpen) this.cartDrawer.setAttribute('aria-hidden', 'false');
          }
          this.updateCartBadge(cart, doc);
        } else {
          this.updateCartBadge(cart);
          this.updateUpsellVisibility(cart);
        }

        this.applyCheckoutDiscount(cart);
        this.updateUpsellArrows();
      } catch (e) {
        console.error(e);
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    }

    // Keyboard Events
    bindKeyboardEvents() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.drawer && this.drawer.getAttribute('aria-hidden') === 'false') this.closeDrawer();
          if (this.search && this.search.getAttribute('aria-hidden') === 'false') this.closeSearch();
          if (this.cartDrawer && this.cartDrawer.getAttribute('aria-hidden') === 'false') this.closeCartDrawer();
        }
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.openSearch();
        }
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeaderController());
  } else {
    new HeaderController();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // Keep empty for compatibility

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-items"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.recommended-carousel');
    if (!section) return;
    
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var slides = track.querySelectorAll('.recommended-carousel__slide');
    
    if (!track || slides.length === 0) return;
    
    var currentIndex = 0;
    var autoSlideInterval;
    var slidesPerView = 4;
    var maxIndex = Math.max(0, slides.length - slidesPerView);
    
    function updateSlidesPerView() {
      if (window.innerWidth <= 640) {
        slidesPerView = 1;
      } else if (window.innerWidth <= 768) {
        slidesPerView = 2;
      } else if (window.innerWidth <= 1200) {
        slidesPerView = 3;
      } else {
        slidesPerView = 4;
      }
      maxIndex = Math.max(0, slides.length - slidesPerView);
      currentIndex = Math.min(currentIndex, maxIndex);
      updateCarousel();
    }
    
    function updateCarousel() {
      var slideWidth = slides[0].offsetWidth;
      var gap = 5;
      var offset = -(currentIndex * (slideWidth + gap));
      track.style.transform = 'translateX(' + offset + 'px)';
      
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    function goToNext() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      } else {
        currentIndex = 0;
        updateCarousel();
      }
    }
    
    function goToPrev() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }
    
    function startAutoSlide() {
      stopAutoSlide();
      autoSlideInterval = setInterval(function() {
        goToNext();
      }, 5000);
    }
    
    function stopAutoSlide() {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
      }
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToPrev();
        stopAutoSlide();
        startAutoSlide();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToNext();
        stopAutoSlide();
        startAutoSlide();
      });
    }
    
    window.addEventListener('resize', updateSlidesPerView);
    updateSlidesPerView();
    
    if (slides.length > slidesPerView) {
      startAutoSlide();
    }
    
    section.addEventListener('mouseenter', stopAutoSlide);
    section.addEventListener('mouseleave', function() {
      if (slides.length > slidesPerView) {
        startAutoSlide();
      }
    });
    
    // Color swatch functionality
    var hasHover = window.matchMedia('(hover: hover)').matches;
    function getColorKey(str) { return (str || '').trim().toLowerCase(); }
    function getImagesByColor(wrapper) {
      var main = {}, hover = {};
      wrapper.querySelectorAll('.collection-grid__image--color[data-color][data-role]').forEach(function(img) {
        var key = getColorKey(img.getAttribute('data-color'));
        var role = (img.getAttribute('data-role') || '').trim();
        if (role === 'main') main[key] = img;
        if (role === 'hover') hover[key] = img;
      });
      return { main: main, hover: hover };
    }
    function setVisible(wrapper, imagesByColor, displayColor, useHover) {
      var key = getColorKey(displayColor);
      var mainEl = imagesByColor.main[key];
      var hoverEl = imagesByColor.hover[key];
      wrapper.querySelectorAll('.collection-grid__image--color').forEach(function(img) {
        img.classList.remove('collection-grid__image--visible');
      });
      if (useHover && hoverEl) {
        hoverEl.classList.add('collection-grid__image--visible');
      } else if (mainEl) {
        mainEl.classList.add('collection-grid__image--visible');
      }
    }
    section.querySelectorAll('.collection-grid__item--has-colors').forEach(function(item) {
      var wrapper = item.querySelector('.collection-grid__image-wrapper');
      var swatchesEl = item.querySelector('.collection-grid__swatches');
      if (!wrapper || !swatchesEl) return;
      var imagesByColor = getImagesByColor(wrapper);
      var firstMainEl = wrapper.querySelector('.collection-grid__image--color[data-role="main"]');
      var firstColorKey = firstMainEl ? getColorKey(firstMainEl.getAttribute('data-color')) : (Object.keys(imagesByColor.main)[0] || null);
      var activeBtn = swatchesEl.querySelector('.collection-grid__swatch--active');
      var selectedColor = item.getAttribute('data-selected-color') || (activeBtn ? activeBtn.getAttribute('data-color') : '') || '';
      var previewColor = null;
      function getDisplayColor() { return previewColor || selectedColor || firstColorKey || ''; }
      function showMain() { setVisible(wrapper, imagesByColor, getDisplayColor(), false); }
      function showHover() { setVisible(wrapper, imagesByColor, getDisplayColor(), true); }
      setVisible(wrapper, imagesByColor, selectedColor || firstColorKey, false);
      swatchesEl.querySelectorAll('.collection-grid__swatch').forEach(function(btn) {
        var color = btn.getAttribute('data-color');
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.getAttribute('data-variant-id');
          var url = item.href || '';
          if (variantId && url) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variantId;
            window.location.href = url;
            return;
          }
          selectedColor = color;
          item.setAttribute('data-selected-color', color);
          previewColor = null;
          setVisible(wrapper, imagesByColor, color, false);
          swatchesEl.querySelectorAll('.collection-grid__swatch').forEach(function(b) {
            b.classList.remove('collection-grid__swatch--active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('collection-grid__swatch--active');
          btn.setAttribute('aria-pressed', 'true');
        });
        if (hasHover) {
          btn.addEventListener('mouseenter', function() {
            previewColor = color;
            setVisible(wrapper, imagesByColor, color, false);
          });
          btn.addEventListener('mouseleave', function() {
            previewColor = null;
            showMain();
          });
        }
      });
      if (hasHover) {
        wrapper.addEventListener('mouseenter', function() { showHover(); });
        wrapper.addEventListener('mouseleave', function() { showMain(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
